/**
 * @example
 *   import Dialog from '@mui/material/Dialog'
 *   import { SlideUp } from 'components/Transitions'
 *
 *   <Dialog open TransitionComponent={SlideUp}>DEMO</Dialog>
 */

import { forwardRef } from 'react'

import Slide, { SlideProps } from '@mui/material/Slide'

export const SlideUp = forwardRef<unknown, SlideProps>(function SlideUp(
  props,
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />
})
